module.exports = __webpack_public_path__ + "img/app-store.4d012d0a.png";